/**
 * Копирование в буфер.
 *
 * `navigator.clipboard` есть не везде: в не-secure context и в старых WebView его
 * просто нет, а в некоторых клиентах Telegram запись отклоняется. Поэтому не бросаем,
 * а возвращаем признак успеха: вызывающий сам решает, предложить ли шаринг.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** Ссылка на нативный шаринг Telegram — фолбэк, когда буфер недоступен. */
export function telegramShareUrl(url: string, text: string): string {
  return `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
}
